import React from 'react';
import { Users, Award, Gift } from 'lucide-react';
import { StatCard, ReferralBox } from './components/SponsorshipComponents';
import { SponsorshipStats } from './types';

interface SponsorshipProps {
  stats: SponsorshipStats | null;
  copied: boolean;
  onCopy: () => void;
  onWhatsApp: () => void;
  onLinkedIn: () => void;
  onEmail: () => void;
}

export const DesktopSponsorship: React.FC<SponsorshipProps> = ({ 
  stats, 
  copied, 
  onCopy, 
  onWhatsApp, 
  onLinkedIn,
  onEmail
}) => {
  console.log('[DesktopSponsorship] Render method called. Stats:', stats);

  return (
    <div className="sponsorship-container desktop-view">
      <div className="sponsorship-header">
        <div className="sponsorship-badge">
          <Gift size={20} />
          <span>Programme de Parrainage</span>
        </div>
        <h1>Offrez 15 jours, Gagnez 1 mois Pro !</h1>
        <p className="subtitle">
          Invitez vos amis à découvrir Kaneabourse. Ils reçoivent un essai Pro gratuit, 
          et vous gagnez un mois d'abonnement pour chaque ami qui s'abonne.
        </p>
      </div>

      <div className="sponsorship-grid">
        <div className="desktop-stats-row">
          <StatCard 
            icon={<Users size={24} className="text-blue" />} 
            label="Amis Inscrits" 
            value={stats?.total_referrals || 0} 
            isMobile={false}
          />
          <StatCard 
            icon={<Award size={24} className="text-green" />} 
            label="Abonnements Validés" 
            value={stats?.validated_referrals || 0} 
            isMobile={false}
          />
          <StatCard 
            variant="highlight"
            label="Jours Pro Gagnés"
            value={stats?.pro_days_earned || 0}
            subValue="jours"
            isMobile={false}
          />
        </div>

        <ReferralBox 
          shareLink={stats?.share_link} 
          referralCode={stats?.referral_code}
          isMobile={false}
          copied={copied}
          onCopy={onCopy}
          onWhatsApp={onWhatsApp}
          onLinkedIn={onLinkedIn}
          onEmail={onEmail}
        />
      </div>

      <div className="sponsorship-steps">
        <h2>Comment ça marche ?</h2>
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <h4>Partagez votre lien</h4>
            <p>Envoyez votre code unique à vos contacts investisseurs.</p>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <h4>15 jours offerts</h4>
            <p>Vos amis reçoivent un accès Pro gratuit pour découvrir Kaneabourse.</p>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <h4>Gagnez 1 mois</h4>
            <p>Dès qu'un ami s'abonne, vous gagnez immédiatement 1 mois d'abonnement Pro.</p>
          </div>
        </div>
      </div>
    </div>
  );
};
